export const firmaElectronica = 145000;

/**
     * Calcula el descuento de firma electrónica de un crédito al momento de solicitar el crédito usar versión 1
     * @param {number} requestedAmount Monto solicitado ej. 200000
     * @param {number} termInDays plazo en días ej. 15
*/
export const calcDescuentoFirmaElectronicaV1 = (requestedAmount, termInDays) => {
    let dctoFirmaElectronica = 0;
    if (termInDays > 15) {
        dctoFirmaElectronica = firmaElectronica * (50 / 100) - (requestedAmount - 200000) * (14 / 100);
    } else {
        dctoFirmaElectronica = firmaElectronica * (65 / 100) - (requestedAmount - 200000) * (14 / 100);
    }

    if (dctoFirmaElectronica > firmaElectronica || dctoFirmaElectronica < 0) {
        dctoFirmaElectronica = firmaElectronica;
    }
    if (dctoFirmaElectronica === firmaElectronica) dctoFirmaElectronica = 0;
    return dctoFirmaElectronica;
}